import { Bounds, namespace, Point } from '../../../../../FrontendBundle/Resources/js/ofcs';
import ContainerItem from './containerItem';

namespace('Ofcs.Editor.Item');

/**
 * @class PhotoMountItem
 * @extends ContainerItem
 */
export default window.Ofcs.Editor.Item.PhotoMountItem = ContainerItem.extend({

    type: 'photoMount',

    /**
     * Triggered when the segments are updated
     *
     * @event updatesegments
     * @param {PhotoMountItem} item Me
     */

    defaults: {
        /**
         * @property {string} Type
         */
        type: null,

        /**
         * Current position
         * @property {Point} attributes.position
         */
        position: new Point(0, 0),

        /**
         * Width of the foam
         * @property {number} attributes.width
         */
        width: 0,

        /**
         * Height of the foam
         * @property {number} attributes.height
         */
        height: 0,

        /**
         * Path to layout image
         * @property {string} attributes.layoutImage
         */
        layoutImage: '',

        /**
         * Path to background image
         * @property {string} attributes.backgroundImage
         */
        backgroundImage: '',
    },

    initialize() {
        ContainerItem.prototype.initialize.call(this);
    },

    /**
     * Returns a new bounding box based on the current *attributes* of the item
     *
     * @return {Bounds} Bounding box of the item
     */
    getBounds() {
        const position = this.get('position');

        return this.cache.get('bounds', () => new Bounds(
            position.clone(),
            new Point(position.x + this.get('width'), position.y + this.get('height')),
        ));
    },
});
